import React from 'react';

const lazy = (factory) => React.lazy(factory);

const SERVICE_LOADERS = {
  marketplace: () =>
    import('../../views/dashboard/WorkflowIntroductionComponent').then((m) => ({
      default: m.default,
    })),
  'dataset-search': () =>
    import('../../views/workspace/DatasetSearchView').then((m) => ({
      default: m.DatasetSearchContent,
    })),
  'workflow-creator': () =>
    import('../../views/dashboard/WorflowCreatorComponent').then((m) => ({
      default: m.default,
    })),
  'workflow-editor': () =>
    import('../../views/dashboard/WorkflowEditorComponent').then((m) => ({
      default: m.default,
    })),
  'data-visualization': () =>
    import('../../views/dashboard/DataVisualizationComponentV2').then((m) => ({
      default: m.default,
    })),
  'map-visualization': () =>
    import('../../views/dashboard/MapVisualizationComponent').then((m) => ({
      default: m.default,
    })),
  'file-explorer': () =>
    import('../../views/dashboard/FileExplorerComponent').then((m) => ({
      default: m.default,
    })),
  'xr-vr': () =>
    import('../../views/xrvr/XrVrComponent').then((m) => ({
      default: m.default,
    })),
};

const componentCache = {};

export const getServiceComponent = (key) => {
  if (!SERVICE_LOADERS[key]) return null;
  if (!componentCache[key]) {
    componentCache[key] = lazy(SERVICE_LOADERS[key]);
  }
  return componentCache[key];
};
